/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class DealContactPickerDialog extends Serenity.TemplatedDialog<CtDealPickerOptions> {

        private checkGrid: DealContactCheckGrid;

        constructor(opt: CtDealPickerOptions) {
            super(opt);

            this.checkGrid = new DealContactCheckGrid(this.byId("CheckGrid"), opt);
            this.dialogTitle = "Select Contacts";
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

        protected getDialogButtons() {
            return [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.checkGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Please select some contacts!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
        }

        get selectedItems() {
            return this.checkGrid.selectedItems;
        }

        public onSuccess: (selected: Nobox.LeadRow[]) => boolean;
    }
}